(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  if (window.innerWidth <= 749) {
    document.addEventListener('DOMContentLoaded', function() {
      const stickyFooter = document.querySelector('[data-sticky-mobile="true"]');
      
      if (stickyFooter) {
        // Set CSS variable for body padding
        const footerHeight = stickyFooter.offsetHeight;
        document.documentElement.style.setProperty('--sticky-footer-height', footerHeight + 'px');
        
        // Update padding on resize
        window.addEventListener('resize', function() {
          const footerHeight = stickyFooter.offsetHeight;
          document.documentElement.style.setProperty('--sticky-footer-height', footerHeight + 'px');
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-section"] && !Shopify.designMode) return;
  try {
    
  if (window.innerWidth <= 749) {
    document.addEventListener('DOMContentLoaded', function() {
      const stickySection = document.querySelector('.section-wrapper--sticky-mobile');
      
      if (stickySection) {
        // Get button height from data attribute
        const buttonHeight = stickySection.getAttribute('data-button-height') || '60';
        document.documentElement.style.setProperty('--button-height', buttonHeight + 'px');
        
        // Set CSS variable for body padding
        const sectionHeight = stickySection.offsetHeight;
        document.documentElement.style.setProperty('--sticky-section-height', sectionHeight + 'px');
        
        // Force remove any bottom spacing
        document.body.style.marginBottom = '0';
        const main = document.querySelector('main') || document.querySelector('#MainContent');
        if (main) {
          main.style.marginBottom = '0';
          main.style.paddingBottom = '0';
        }
        
        // Update padding on resize
        window.addEventListener('resize', function() {
          const sectionHeight = stickySection.offsetHeight;
          document.documentElement.style.setProperty('--sticky-section-height', sectionHeight + 'px');
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
